import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText
} from 'reactstrap';

function Footer (){
  return (
    <footer className="site-footer">
        <div className="container">
          <div className="row justify-content-around">
            <div className="col-5">
              <img className="" src="http://crdascz.com/CRDASCZ/wp-content/uploads/2020/12/cropped-LogoCRDASC-04-2048x2048.png" width="72" height="72" />
              <br/><br/>
              <p className="letra">
                La <a className="text-success" href="http://www.crdascz.com/index.html">Cámara Regional de Despachantes de Aduana de Santa Cruz de La Sierra “C.R.D.A. SC”</a>, fue fundada y constituida en la ciudad de Santa Cruz de la Sierra en fecha 16 de Marzo de 1969.
              </p>
              <br/>
            </div>
            <div className="col-2"></div>
            <div className="col-5">
              <h6>Contactos</h6>
              <br/>
              <ul className="footer-links letra">
                <li>Dirección Oficina Central: Calle Ballivián #911</li>
                <li>Teléfono: (591)3364830</li>
                <li>Fax: (591)3332231</li>
                <li>Correo electrónico: camararegional@crdascz.com</li>
              </ul>
            </div>
          </div>
        </div>
     </footer>
  )
}

export default Footer;
